(function() {
    'use strict';

    angular
        .module('fileUploadApp')
        .controller('ReportsController', ReportsController);

    ReportsController.$inject = ['Principal', 'Auth','$http','AlertService'];

    function ReportsController (Principal, Auth, $http, AlertService) {
        var vm = this;

        vm.requestDailyFileUploadedReport = requestDailyFileUploadedReport;
        /**
         * Store the "settings account" in a separate variable, and not in the shared "account" variable.
         */
        var copyAccount = function (account) {
            return {
                activated: account.activated,
                email: account.email,
                firstName: account.firstName,
                langKey: account.langKey,
                lastName: account.lastName,
                login: account.login
            };
        };

        Principal.identity().then(function(account) {
            vm.settingsAccount = copyAccount(account);
        });


        function requestDailyFileUploadedReport(){
            console.log("calling report generation");
        	$http({
    			url: 'api/report/dailyFileUploadReport',
    			method: 'GET',
                params: {reportDate: vm.reportDate}
    		}).then(function(response) {
                console.log(response);
                //AlertService.success("Request submitted!");
    		});
        }
    }
})();
